<template>
  <div style="max-width: 600px" class="chart">
    <!-- <vue3-chart-js v-bind="{ ...barChart }" /> -->

    <div v-show="categories">
      <div class="legends">
        <div v-for="(legend, index) in legends" :key="index" class="legend">
          <div class="color" :style="{ backgroundColor: legend.color }"></div>
          <div class="name">{{ legend.name }}</div>
        </div>
      </div>
      <iframe
        :src="appRoot + '/html/charjs.html?categories=' + categories"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>
<style lang="scss">
iframe {
  max-width: 600px;
  width: 600px;
  // min-height:430px;
}
</style>

<script>
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";

export default {
  name: "App",
  components: {
    Vue3ChartJs,
  },
  props: ["values", "categories"],
  data: () => ({
    legends: [
      {
        name: "Strategy",
        color: "#8060C2",
      },
      {
        name: "Culture & People",
        color: "#97D3AF",
      },
      {
        name: "Processes",
        color: "#E96F68",
      },
      {
        name: "Technology",
        color: "#FFD772",
      },
    ],
  }),
  setup(context, props) {
    if (!context.values) {
      return false;
    }

    const barChart = {
      type: "bar",
      options: {
        indexAxis: "y",
        // min: 0,
        // max: 100,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "top",
          },
        },
        tooltips: {
          callbacks: {
            label: (item) => `${item.yLabel}`,
          },
        },
        legend: {
          labels: {
            fontColor: "white",
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "white",
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                fontColor: "white",
                beginAtZero: true,
              },
            },
          ],
        },
      },
      data: {
        labels: context.values.categories,
        datasets: [
          {
            label: "Categorias",
            backgroundColor: [
              "#8060C2CC",
              "#97D3AFCC",
              "#E96F68CC",
              "#FFD772CC",
            ],
            data: context.values.count,
          },
        ],
      },
    };

    // change color font of the labels
    // barChart.options.scales.yAxes[0].ticks.fontColor = "white";

    return {
      barChart,
    };
  },
  created() {
    this.appRoot = process.env.VUE_APP_ROOT;
  },
};
</script>
